/**
 * Clershion · "Completa il look": revela un subconjunto aleatorio de las
 * sugerencias del carrito (3 de accesorios + 1 de otra categoria) y conecta
 * las flechas de desplazamiento.
 *
 * El carrito reemplaza su propio HTML por completo cada vez que se agrega,
 * quita o cambia la cantidad de un producto (via innerHTML), asi que un
 * <script> normal dentro de ese HTML solo se ejecutaria una vez. Por eso
 * este archivo se carga UNA VEZ de forma global (layout/theme.liquid) y usa
 * un MutationObserver para detectar cada vez que aparece un carrusel nuevo
 * (incluido el de la primera carga), y lo procesa en ese momento.
 */
(function () {
  function shuffle(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = array[i];
      array[i] = array[j];
      array[j] = tmp;
    }
    return array;
  }

  function revealGroup(track, groupKey, count) {
    var items = Array.prototype.filter.call(track.children, function (li) {
      return li.dataset.clershionCuGroup === groupKey;
    });
    shuffle(items);
    items.forEach(function (li, index) {
      li.style.display = index < count ? '' : 'none';
    });
  }

  function setupTrack(track) {
    if (track.dataset.clershionCuDone) return;
    track.dataset.clershionCuDone = 'true';

    var show = (track.dataset.clershionCuShow || '3,1').split(',');
    revealGroup(track, 'a', parseInt(show[0], 10) || 0);
    revealGroup(track, 'b', parseInt(show[1], 10) || 0);

    var wrapper = track.closest('.clershion-cart-upsell');
    if (!wrapper) return;
    var prevBtn = wrapper.querySelector('.clershion-cart-upsell__arrow--prev');
    var nextBtn = wrapper.querySelector('.clershion-cart-upsell__arrow--next');
    var step = 187;
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -step, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: step, behavior: 'smooth' });
      });
    }
  }

  function processAll() {
    document.querySelectorAll('[data-clershion-cu-pool]').forEach(setupTrack);
  }

  function init() {
    processAll();
    var root = document.getElementById('CartDrawer') || document.body;
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return m.type === 'childList';
      });
      if (relevant) processAll();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
